import {
  Box,
  Button,
  Chip,
  FormLabel,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { ChevronLeft } from "react-feather";
import { useTheme } from "@mui/system";
import Attivita from "../tabs/dettagli/Attivita";
import Condizioni from "../tabs/dettagli/Condizioni";
import Documenti from "../tabs/dettagli/Documenti";
import Dettagli from "./Dettagli";
import Precontrattuale from "../tabs/dettagli/Precontrattuale";
import { TabsWrapper } from "../style";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const VaiAiDettagli = ({ setVaiSection, dataset }) => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const item = dataset[0];
  return (
    <Box sx={{ width: "100%" }}>
      <Button onClick={() => setVaiSection(false)}>
        <ChevronLeft />
        <FormLabel>Torna indietro</FormLabel>
      </Button>
      {/* {dataset[0]?.idUID} */}
      <Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={4}>
        <Box width={isMobile ? "100%" : "50%"}>
          <TabsWrapper>
            <Tabs
              value={activeTab}
              onChange={(_, newValue) => setActiveTab(newValue)}
              sx={{
                width: "100%",
                mt: 2,
                mb: 4,
                backgroundColor:
                  theme.palette.mode === "light" ? "#fff" : "#233044",
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label="Attività" />
              <Tab label="Condizioni" />
              <Tab label="Documenti" />
              <Tab label="Precontrattuale" />
            </Tabs>
            <CustomTabPanel value={activeTab} index={0}>
              {/* <RCA dataset={rca} /> */}
              <Attivita />
            </CustomTabPanel>
            <CustomTabPanel value={activeTab} index={1}>
              {/* <CVT dataset={cvt} /> */}
              <Condizioni />
            </CustomTabPanel>
            <CustomTabPanel value={activeTab} index={2}>
              {/* <CVT dataset={cvt} /> */}
              <Documenti />
            </CustomTabPanel>
            <CustomTabPanel value={activeTab} index={3}>
              {/* <CVT dataset={cvt} /> */}
              <Precontrattuale />
            </CustomTabPanel>
          </TabsWrapper>
        </Box>
        <Box width={isMobile ? "100%" : "50%"} mt={2}>
          <Box width="100%" mb={4}>
            <Chip
              sx={{
                backgroundColor: `#${item?.sCol}`,
                color: item?.sCol === "336699" ? "white" : "black",
                fontSize: 18,
                fontWeight: "bold",
                width: "100%",
                height: "3rem",
              }}
              label={item?.sDesc}
            />
          </Box>
          <Dettagli idUID={item?.idUID} type="RCA" />
        </Box>
      </Box>
    </Box>
  );
};

export default VaiAiDettagli;
